import { useEffect, useMemo } from 'react'

import type { Mode } from 'core/domain/Mode'
import type { Option } from 'core/domain/Option'
import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { formatChargeTypeNameWithSuffix } from '../../presenters/shipmentChargePresenter'
import { getShipmentChargeTypes } from '../../use-cases/getShipmentChargeTypes'

export function useShipmentChargeTypes({ mode, enabled }: { mode: Mode; enabled: boolean }) {
  const { call, reset, result, status } = useAsync(getShipmentChargeTypes)
  const abortController = useAbortController()

  useEffect(() => {
    if (enabled) {
      call(mode, abortController)
    } else {
      reset()
    }
  }, [call, reset, enabled, mode, abortController])

  const shipmentChargeTypes: Array<Option<string>> = useMemo(
    () =>
      (result ?? [])
        .filter(chargeType => chargeType.isAccessorial)
        .map(chargeType => ({
          label: formatChargeTypeNameWithSuffix(chargeType),
          value: chargeType.code,
        })),
    [result]
  )

  return {
    shipmentChargeTypes,
    shipmentChargeTypesStatus: status,
  }
}
